import { AI_FREE_YANDEX, AI_YANDEX } from '../../configs/AI';
import { FORMULA_TYPES } from '../../configs/formula';
import i18n from '../../configs/i18n';
import { getImmutableField } from './getImmutableField';
import { getValidateError } from './getValidateError';

/**
 * Массив для валидации
 *
 * hasError: boolean, наличие ошибки
 * errorType: string, аттрибут, который вызвал ошибку
 * message?: string, текст для ошибки, по умолчанию, "Значение не может быть пустым"
 */
const validations = [
  // Наличие поля token
  {
    hasError: (field) => {
      const service = field.getIn(['formulaConfig', 'service']);
      const token = field.getIn(['formulaConfig', 'token']);
      const hasToken = token && (token.length > 0 || token.size > 0);

      if (service !== AI_FREE_YANDEX && !hasToken) {
        return true;
      }

      return false;
    },
    errorType: 'formulaConfig.token',
  },
  // Наличие поля model
  {
    hasError: (field) => {
      const service = field.getIn(['formulaConfig', 'service']);
      if (service !== AI_FREE_YANDEX && !field.getIn(['formulaConfig', 'model'])) {
        return true;
      }

      return false;
    },
    errorType: 'formulaConfig.model',
  },
  // Наличие поля folderId
  {
    hasError: (field) => {
      const service = field.getIn(['formulaConfig', 'service']);
      const folderId = field.getIn(['formulaConfig', 'folderId']);
      const hasToken = folderId && (folderId.length > 0 || folderId.size > 0);

      if (service === AI_YANDEX && !hasToken) {
        return true;
      }

      return false;
    },
    errorType: 'formulaConfig.folderId',
  },
  // Наличие поля промпт
  {
    hasError: (field) => !field.getIn(['formulaConfig', 'prompt']),
    errorType: 'formulaConfig.prompt',
  },
];

export const validateAiConfig = (field, allFields) => {
  const immutField = getImmutableField(field);
  if (immutField.get('formulaType') !== FORMULA_TYPES.AI) {
    return [];
  }

  const errors = [];
  validations.map((v) => {
    if (v.hasError(field, allFields)) {
      const error = getValidateError(immutField, v.errorType, v.message ?? i18n.t('modals.aiErrors.notValue'));
      errors.push(error);
    }
  });

  return errors;
};
